/**
 * Main application entry point.
 */

'use strict';

var app = require('mag-app');


app.once('load', function () {
    require('spa-gettext').load({name: core.environment.language}, function () {
        app.radioBackend = core.plugins.radioBackend;

        require('./modules/saver').init(true, false);

        app.pages = {
            main: require('./pages/main')
        };

        app.radioBackend.getRadioChannels({favorite: app.state.favoritesActive}, function ( error, data ) {
            if ( !error ) {
                app.route(app.pages.main, data);
                app.ready();
            }
        });
    });
});
